import Phaser from 'phaser';
import { PixelCanvas } from './pixel/PixelCanvas';
import type { Memorial } from '@/domain/world/memorial';

export interface MemorialRendererHandle {
  container: Phaser.GameObjects.Container;
  destroy(): void;
}

const PIXEL_SCALE = 4;

export function buildMemorialRenderer(
  scene: Phaser.Scene,
  m: Memorial,
): MemorialRendererHandle {
  const container = scene.add.container(m.x, m.y).setScale(PIXEL_SCALE);
  container.setDepth(6);
  const g = scene.add.graphics();
  const px = new PixelCanvas(g);
  drawTombstone(px);
  container.add(g);

  // Label invisível por padrão (mostra ao hover/click)
  const label = scene.add
    .text(m.x, m.y - 32, `† ${m.npcName}`, {
      fontFamily: 'monospace',
      fontSize: '10px',
      color: '#dddddd',
      stroke: '#000',
      strokeThickness: 2,
    })
    .setOrigin(0.5)
    .setDepth(50);

  return {
    container,
    destroy(): void {
      label.destroy();
      container.destroy();
    },
  };
}

function drawTombstone(px: PixelCanvas): void {
  // 8 wide × 12 tall lápide
  // base (terra)
  const k = 0x1a1a14;
  const stoneL = 0xc8c8c8;
  const stone = 0x9a9a9a;
  const stoneD = 0x6a6a6a;
  const cross = 0x6a4423;
  // corpo arredondado
  px.rect(-3, -4, 7, 8, stone);
  px.rect(-2, -5, 5, 1, stone);
  px.px(-1, -6, stone);
  px.px(0, -6, stone);
  px.px(1, -6, stone);
  // outline
  px.rect(-3, -4, 1, 8, k);
  px.rect(3, -4, 1, 8, k);
  px.rect(-2, -5, 5, 1, k);
  px.px(-1, -6, k);
  px.px(0, -6, k);
  px.px(1, -6, k);
  // highlight
  px.rect(-2, -4, 1, 5, stoneL);
  // sombra direita
  px.rect(2, -3, 1, 5, stoneD);
  // cruz
  px.vLine(0, -4, 4, cross);
  px.hLine(-1, -3, 3, cross);
  // chão / sombra
  px.rect(-4, 4, 9, 1, k);
  px.rect(-3, 5, 7, 1, 0x4a3018);
}
